import React from 'react';
import { Modal } from 'react-bootstrap';

const Simplemsg = ({
    show,
    onClose,
    title = "Success!",
    message = "Your data added successfully.",
    buttonText = "OK, got it!"
}) => {
    return (
        <Modal
            show={show}
            onHide={() => {
                onClose();
                window.scrollTo(0, 0); // Ensure the scroll-to-top functionality is preserved
            }}
            centered
            id="success_tic"
            className="model-thank-you"
        >
            <Modal.Body>
                <h2 className="text-center mb-3">{title}</h2>
                <p className="text-center mb-4">{message}</p>
                <button
                    type="button"
                    className="btn btn-modal-view"
                    onClick={onClose}
                >
                    {buttonText}
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default Simplemsg;
